import { Button } from '@cobliteam/ui/components';

import { MediaType } from '@cobliteam/common-types';

import { useGetMediaView } from '@cobliteam/hooks/src/useCamera/useCameraMedia';

import Icon from '@cobliteam/ui/icons';

import EventSensibilityButton from '../../../../containers/EventSensibilityButton';
import useMediaStore from '../../../../store/zustand/useMediaStore';

export interface MediaDialogFooterProps {
  onNextMediaClick?: () => void;
  onPreviousMediaClick?: () => void;
  hasNextMedia?: boolean;
  hasPreviousMedia?: boolean;
  isNavigationButtonsDisabled?: boolean;
  isFetchingMediaRows?: boolean;
  redirectButton?: JSX.Element;
}

const MediaDialogFooter = ({
  onNextMediaClick,
  onPreviousMediaClick,
  isNavigationButtonsDisabled,
  hasPreviousMedia,
  hasNextMedia,
  isFetchingMediaRows,
  redirectButton,
}: MediaDialogFooterProps) => {
  const mediaViewId = useMediaStore((state) => state.mediaViewId);
  const { data: mediaView } = useGetMediaView(mediaViewId);
  const mediaData = mediaView?.mediaInfo;
  const isEventVideo = mediaData && mediaData.mediaType === MediaType.EVENT_VIDEO;

  const handlePreviousMediaClick = () => {
    if (onPreviousMediaClick) {
      onPreviousMediaClick();
    }
  };

  const handleNextMediaClick = () => {
    if (onNextMediaClick) {
      onNextMediaClick();
    }
  };

  return (
    <div className={`flex ${isEventVideo ? 'justify-between' : 'justify-end'} p-5`}>
      {isEventVideo && <EventSensibilityButton hasIcon />}
      {!isNavigationButtonsDisabled && (
        <div className='flex'>
          <Button variant='text' onClick={handlePreviousMediaClick} startIcon={<Icon name='arrow-left' />} disabled={!hasPreviousMedia} loading={isFetchingMediaRows || !mediaData}>
            Voltar
          </Button>
          <Button variant='contained' onClick={handleNextMediaClick} endIcon={<Icon name='arrow-right' />} disabled={!hasNextMedia} loading={isFetchingMediaRows || !mediaData}>
            Próximo
          </Button>
        </div>
      )}
      {redirectButton && redirectButton}
    </div>
  );
};

export default MediaDialogFooter;
